/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
    {
        id: 1,
        message: "You are beautiful",
    },
    {
        id: 2,
        message: "May your day be filled with wonder",
    },
    {
        id: 3,
        message: "May the force be with you",
    },
    {
        id: 4,
        message: "Let your light shine",
    },
    {
        id: 5,
        message: "Hold onto your dreams",
    },
    {
        id: 6,
        message: "A pearl has a humble beginning as a grain of sand",
    },
    {
        id: 7,
        message: "Hang in there",
    },
    {
        id: 8,
        message: "That which animates your body is immortal",
    },
    {
        id: 9,
        message: "Divinity is your birthright",
    },
    {
        id: 10,
        message: "Love is all there is",
    },
    {
        id: 11,
        message: "What would love do now?",
    },
    {
        id: 12,
        message: "Your body is a temple",
    },
    {
        id: 13,
        message: "That which you give to another you give to yourself",
    },
    {
        id: 14,
        message: "Life shows up perfectly in every given moment",
    },
    {
        id: 15,
        message: "You are a wonder to behold",
    },
    {
        id: 16,
        message: "Love like you have nothing to lose",
    },
    {
        id: 17,
        message: "Honor yourself by saying no",
    },
    {
        id: 18,
        message: "You mean the world to someone",
    },
    {
        id: 19,
        message: "You are loved and supported",
    },
    {
        id: 20,
        message: "Every day brings new opportunities",
    },
    {
        id: 21,
        message: "The world is a better place because of you",
    },
    {
        id: 22,
        message: "You are enough, just as you are",
    },
    {
        id: 23,
        message: "Every step forward is progress",
    },
    {
        id: 24,
        message: "Your presence is a gift to the world",
    },
    {
        id: 25,
        message: "Greatness lives within you",
    },
    {
        id: 26,
        message: "The best is yet to come",
    },
    {
        id: 27,
        message: "You have more strength than you know",
    },
    {
        id: 28,
        message: "Joy is your natural state",
    },
    {
        id: 29,
        message: "Trust the journey",
    },
    {
        id: 30,
        message: "You are a force of nature",
    },
    {
        id: 31,
        message: "Your kindness changes the world",
    },
    {
        id: 32,
        message: "Peace begins with you",
    },
    {
        id: 33,
        message: "You were made for great things",
    },
    {
        id: 34,
        message: "Believe in the magic of new beginnings",
    },
    {
        id: 35,
        message: "Your story is still being written",
    },
    {
        id: 36,
        message: "Be the light you wish to see",
    },
]